import React from 'react';

import { css } from '@betterment/samba-styled-system/css';
import { useColorMode } from '@betterment/shared-components/src/components/color-mode/ColorModeProvider';

import { ProductOnboardingCrossSellItem } from './ProductOnboardingCrossSellItem';

import secLendingDark from '../../../images/sec_lending_dark.svg';
import secLendingLight from '../../../images/sec_lending_light.svg';
import { urlBuilder } from '../../../Shared/urlBuilder';

export const SecuritiesLendingCrossSellItem: React.FC = () => {
  const { colorMode } = useColorMode();
  const iconSrc = colorMode === 'dark' ? secLendingDark : secLendingLight;

  const settingsUrl = `${urlBuilder.appEditUserLevelSettings.absolute()}?return_to=${encodeURIComponent(
    urlBuilder.appHome.absolute()
  )}`;

  return (
    <ProductOnboardingCrossSellItem
      name="Securities lending"
      description=""
      icon={<img src={iconSrc} alt="Securities lending icon" className={css({ width: '36px', height: '36px' })} />}
      to={settingsUrl}
      analyticsKey="securities_lending"
    />
  );
};
